// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner_wapper {
  text-align: center;
}
.banner_wapper > img {
  object-fit: contain;
  max-height: 200px;
  max-width: 100%;
}
.align-baseline {
  align-items: baseline;
}
.align-start {
  align-items: flex-start;
}
.product-wapper {
  display: flex;
  gap: 16px;
  flex-wrap: nowrap;
  overflow-x: scroll;
  max-width: 100%;
}
.catalog-wapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 32px;
}
.catalog-info {
  background-color: #ccc;
  padding: 8px;
  font-size: 18px;
  display: flex;
  align-items: center;
  gap: 32px;
  max-width: 100%;
}
.product-card {
  display: flex;
  flex-direction: column;
  min-width: 320px;
  border: 1px solid #ccc;
  border-radius: 4px;
  object-fit: contain;
}
.product-card > img {
  object-fit: contain;
  max-height: 148px;
}
.pill {
  font-size: 12px !important;
}
.out-of_stock {
  opacity: 0.5;
}
.border-none {
  border: none;
}
.border-bottom {
  border-bottom: 1px solid #eeeeee;
}
.live-headers {
  font-size: 28px;
}
.live_datePicker .react-datepicker__input-container input {
  margin-top: 0px;
  margin-bottom: 0px;
}
.margin-top-40 {
  margin-top: 40px;
}
.real-esate-image {
  width: 50%;
}

.update_real-estate {
  height: 100px;
}

.filter_input {
  width: 150px;
}
.color-blue {
  color: rgb(18, 57, 175);
}
.live-input-text {
  width: 100%;
  border: 1px solid #e6e6e6;
  padding: 0.5rem 0.75rem;
  font-size: 0.8rem;
  color: #202020;
  font-weight: 500;
  height: 200px;
  white-space: pre;
  overflow-wrap: normal;
  overflow-x: scroll;
}

.live-stream-thumbnail-image {
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 350px;
}

.field-dialog {
  top: auto;
  right: inherit;
}

.max-width-100{
  max-width: 100%;
}

.break-word {
  word-wrap: break-word;
}
`, "",{"version":3,"sources":["webpack://./client/components/dashboard/liveCommerce/liveCommerce.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,gCAAgC;AAClC;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".banner_wapper {\n  text-align: center;\n}\n.banner_wapper > img {\n  object-fit: contain;\n  max-height: 200px;\n  max-width: 100%;\n}\n.align-baseline {\n  align-items: baseline;\n}\n.align-start {\n  align-items: flex-start;\n}\n.product-wapper {\n  display: flex;\n  gap: 16px;\n  flex-wrap: nowrap;\n  overflow-x: scroll;\n  max-width: 100%;\n}\n.catalog-wapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  width: 100%;\n  margin-bottom: 32px;\n}\n.catalog-info {\n  background-color: #ccc;\n  padding: 8px;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  gap: 32px;\n  max-width: 100%;\n}\n.product-card {\n  display: flex;\n  flex-direction: column;\n  min-width: 320px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  object-fit: contain;\n}\n.product-card > img {\n  object-fit: contain;\n  max-height: 148px;\n}\n.pill {\n  font-size: 12px !important;\n}\n.out-of_stock {\n  opacity: 0.5;\n}\n.border-none {\n  border: none;\n}\n.border-bottom {\n  border-bottom: 1px solid #eeeeee;\n}\n.live-headers {\n  font-size: 28px;\n}\n.live_datePicker .react-datepicker__input-container input {\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n.margin-top-40 {\n  margin-top: 40px;\n}\n.real-esate-image {\n  width: 50%;\n}\n\n.update_real-estate {\n  height: 100px;\n}\n\n.filter_input {\n  width: 150px;\n}\n.color-blue {\n  color: rgb(18, 57, 175);\n}\n.live-input-text {\n  width: 100%;\n  border: 1px solid #e6e6e6;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.8rem;\n  color: #202020;\n  font-weight: 500;\n  height: 200px;\n  white-space: pre;\n  overflow-wrap: normal;\n  overflow-x: scroll;\n}\n\n.live-stream-thumbnail-image {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  height: 350px;\n}\n\n.field-dialog {\n  top: auto;\n  right: inherit;\n}\n\n.max-width-100{\n  max-width: 100%;\n}\n\n.break-word {\n  word-wrap: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
